/** @module Camunda/ProcessDefinitionView */
define([
	"dojo/_base/declare",
	"mobx",
	"underscore",
	"csi/router",
	"csi/state/rootStore",
	"csi/view/_FullPageViewMixin",
	"csi/xml",
	"Camunda",
	"./_BpmnWidget",
	"./state/TaskRightPaneComponent"
], function(declare, {runInAction}, _, {confirmLeavePage}, {rightPaneStore, sessionStore}, _FullPageViewMixin, xml, Camunda, _BpmnWidget, TaskRightPaneComponent) {

	return declare([_BpmnWidget, _FullPageViewMixin], {
		/**
		 * @override
		 * Show selected user task in focused view
		 */
		onClickElement: async function(taskId, type, name, description) {
			const cache = this.cacheView;
			const taskDefinitions = cache.getNodes(this.getViewNode().Tasks);
			const processComponent = rightPaneStore.adHocComponent;

			if (processComponent && processComponent.isEditing) {
				const lastTaskId = processComponent.task.Id;

				// do nothing if selected same task as before
				if (taskId === lastTaskId) {
					return;
				}

				// select previous task while confirming user wants to discard any edits
				this._selectTask(lastTaskId);

				try {
					await confirmLeavePage();
				} catch (ex) {
					// leave last task selected
					return;
				}
			}

			let taskDefinition = taskDefinitions.find(({Id}) => Id === taskId);
			if (!taskDefinition && type == this.SERVICE_TASK) {
				// create temp node if the user clicks the service task
				const currentSiteLevelLocale = sessionStore.siteLocale;
				taskDefinition = xml.nodeCreateClientNode(null, "CamundaTaskDefinition", name);
				xml.nodeSetFlags(taskDefinition, xml.NODE_FLAG_NOEDIT);
				xml.nodeCreateClientAttr(taskDefinition, "Info", xml.ATTR_STRINGMAP, {[currentSiteLevelLocale]: description});
				xml.nodeCreateClientAttr(taskDefinition, "Type", xml.ATTR_ENUM, "CamundaTaskType:ServiceTask");
			}

			runInAction(() => {
				if (!taskDefinition) {
					rightPaneStore.adHocComponent = null;
				} else {
					let processComponent = rightPaneStore.adHocComponent;

					if (!processComponent) {
						processComponent = new TaskRightPaneComponent(cache);
						rightPaneStore.setAdHocComponent(processComponent);
					}

					processComponent.setTask(taskDefinition.$URL);
				}

				this._selectTask(taskId);
			});
		},

		/**
		 * Add CSS for user tasks so they can be selected
		 */
		onViewEnd: function() {
			const taskDefinitions = this.cacheView.getNodes(this.getViewNode().Tasks);

			_.each(taskDefinitions, function(taskDefinition) {
				this._addTaskCSS(taskDefinition.Id, Camunda.taskDefinitionIsUserTask(taskDefinition) ? this.CSS_USER_TASK : this.CSS_SERVICE_TASK);
			}, this);
		}
	});
});